<img
	ngSrc="assets/images/peps_academy_logo.png"
	alt="Logo Team Peps"
	[height]="height"
	[width]="width"
	(click)="onClick()"
	(keydown.enter)="onClick()"
	[ngClass]="{'cursor-pointer hover:brightness-110 transition duration-200': hover}"
/>
